import Keycloak from "keycloak-js";

// local configuration
// const my_keycloak = new Keycloak({
//     "realm": "inergy",
//     "url": "https://oblachek.eu:8443/",
//     "clientId": "uc13"
// })

// ICCS deployment configuration
const my_keycloak = new Keycloak({
    "realm": "EnergyGuard",
    "url": "https://keycloak.toolbox.epu.ntua.gr/",
    "clientId": "efi-dss-energyguard"
})

// ========== TEMPORARY DEBUG MODE ==========
// Remove this entire block when Keycloak is ready
// To enable: set REACT_APP_DEBUG_AUTH=true in docker-compose build args
if (process.env.REACT_APP_DEBUG_AUTH === 'true') {
    my_keycloak.init = () => Promise.resolve(true);
    my_keycloak.authenticated = true;
    my_keycloak.token = 'debug-token';
    my_keycloak.tokenParsed = {
        preferred_username: 'Debug User',
        email: 'debug@test.com'
    };
    my_keycloak.realmAccess = {
        roles: ['admin', 'inergy_admin']
    };
    my_keycloak.logout = () => {};
    my_keycloak.login = () => {};
}
// ========== END TEMPORARY DEBUG MODE ==========

export default my_keycloak